/* eslint-disable */
<template>
  <LayoutContentVerticalNav :nav-menu-items="navMenuItems">
    <template #default>
      <slot />
    </template>

    <!-- Slot: Navbar -->
    <template #navbar="{ toggleVerticalNavMenuActive }">
      <div
        class="navbar-content-container"
        :class="{ 'expanded-search': shallShowFullSearch }"
      >
        <!-- Left Content: Search -->
        <div class="d-flex align-center">
          <v-icon
            v-if="$vuetify.breakpoint.mdAndDown"
            class="me-3"
            @click="toggleVerticalNavMenuActive"
          >
            {{ icons.mdiMenu }}
          </v-icon>
        </div>

        <!-- Right Content: I18n, Light/Dark, Notification & User Dropdown -->
        <div class="d-flex align-center right-row">
          <AppBarI18n class="mx-4" />
          <AppBarCurrency class="mx-4" />
          <AppBarExchangeRate class="mx-4" />
          <AppBarThemeSwitcher class="mr-4" />
          <AppBarCar />
          <AppBarUserMenu />
        </div>
      </div>
    </template>

    <!-- Slot: Footer -->
    <template #footer>
      <v-row v-if="$route.path.startsWith('/cotizador')">
        <v-col
          v-if="productCotizador === 'hotel' && cotizadorHotelsResult.length === 0"
          cols="12"
        >
          <v-img
            :src="require(`@/assets/img/cotizador/${productCotizador}.png`)"
            :style="{ width: '100%' }"
            :max-height="160"
          />
        </v-col>
        <v-col
          v-else-if="productCotizador === 'car' && cotizadorCarsResult.length === 0"
          cols="12"
        >
          <v-img
            :src="require(`@/assets/img/cotizador/${productCotizador}.png`)"
            :style="{ width: '100%' }"
            :max-height="160"
          />
        </v-col>
        <v-col
          v-else-if="productCotizador === 'flight' && resultCotizadorIdaFlight.length === 0"
          cols="12"
        >
          <v-img
            :src="require(`@/assets/img/cotizador/${productCotizador}.png`)"
            :style="{ width: '100%' }"
            :max-height="160"
          />
        </v-col>
      </v-row>
      <Copyright />
    </template>
  </LayoutContentVerticalNav>
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex'
import { ref, watch } from '@vue/composition-api'
import { mdiMenu, mdiHeartOutline } from '@mdi/js'
import LayoutContentVerticalNav from '@/@core/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'
import navMenuItems from '@/navigation/vertical'
import { getVuetify } from '@/@core/utils'
import AppBarCar from '@/@core/layouts/components/app-bar/AppBarCar.vue'
import AppBarI18n from '@/@core/layouts/components/app-bar/AppBarI18n.vue'
import AppBarCurrency from '@/@core/layouts/components/app-bar/AppBarCurrency.vue'
import AppBarExchangeRate from '@/@core/layouts/components/app-bar/AppBarExchangeRate.vue'
import AppBarThemeSwitcher from '@/@core/layouts/components/app-bar/AppBarThemeSwitcher.vue'
import AppBarUserMenu from '@/@core/layouts/components/app-bar/AppBarUserMenu.vue'
import Copyright from './Copyright.vue'

export default {
  name: 'LayoutContentVerticalNavWrapper',
  components: {
    LayoutContentVerticalNav,
    Copyright,
    AppBarI18n,
    AppBarCurrency,
    AppBarExchangeRate,
    AppBarThemeSwitcher,
    AppBarUserMenu,
    AppBarCar,
  },

  setup() {
    const $vuetify = getVuetify()

    // Search
    const appBarSearchQuery = ref('')
    const shallShowFullSearch = ref(false)
    const maxItemsInGroup = 5
    const totalItemsInGroup = ref({
      pages: 0,
      files: 0,
      contacts: 0,
    })

    watch(appBarSearchQuery, () => {
      totalItemsInGroup.value = {
        pages: 0,
        files: 0,
        contacts: 0,
      }
    })

    const searchFilterFunc = (item, queryText, itemText) => {
      if (item.header || item.divider) return true

      const itemGroup = (() => {
        if (item.to !== undefined) return 'pages'
        if (item.size !== undefined) return 'files'
        if (item.email !== undefined) return 'contacts'
        return null
      })()

      const isMatched = itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1

      if (isMatched) {
        if (itemGroup === 'pages') totalItemsInGroup.value.pages += 1
        else if (itemGroup === 'files') totalItemsInGroup.value.files += 1
        else if (itemGroup === 'contacts') totalItemsInGroup.value.contacts += 1
      }

      return appBarSearchQuery.value && isMatched && totalItemsInGroup.value[itemGroup] <= maxItemsInGroup
    }

    const handleShallShowFullSearchUpdate = (isVerticalNavMenuActive, toggleVerticalNavMenuActive) => {
      if ($vuetify.breakpoint.mdAndDown && isVerticalNavMenuActive) {
        toggleVerticalNavMenuActive()
      }
    }

    return {
      navMenuItems,
      handleShallShowFullSearchUpdate,
      appBarSearchQuery,
      shallShowFullSearch,
      searchFilterFunc,
      icons: {
        mdiMenu,
        mdiHeartOutline,
      },
    }
  },

  computed: {
    ...mapState({
      searchingHotel: state => state.app.searchingHotel,
      showOcupationRoomHotel: state => state.app.showOcupationRoomHotel,
      cotizadorHotelsResult: state => state.app.cotizadorHotelsResult,
      cotizadorCarsResult: state => state.app.cotizadorCarsResult,
      productCotizador: state => state.app.productCotizador,
      searchingFlightCotizador: state => state.app.searchingFlightCotizador,
      destinosCotizadorFlight: state => state.app.destinosCotizadorFlight,
      resultCotizadorIdaFlight: state => state.app.resultCotizadorIdaFlight,
    }),
  },
}
/* eslint-enable */
</script>

<style lang="scss" scoped>
.navbar-content-container {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  position: relative;
}

.v-app-bar.bg-blur {
  .expanded-search {
    ::v-deep .app-bar-autocomplete-box div[role='combobox'] {
      background-color: transparent;
    }

    > .d-flex > button.v-icon {
      display: none;
    }

    > .right-row {
      visibility: hidden;
      opacity: 0;
    }

    ::v-deep .app-bar-search-toggler {
      visibility: hidden;
    }
  }
}
</style>
